import './text-image-teaser.scss';

import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/scss';

class TextImageTeaser {
    constructor ($element) {
        this.$textImageTeaser = $element;
        this.$tabNav = this.$textImageTeaser.querySelector('[data-text-image-teaser="tab-nav"]');
        this.$alltabNav = this.$textImageTeaser.querySelectorAll('[data-text-image-teaser="tab-nav-item"]');
        this.$activeTab = this.$textImageTeaser.querySelector('[data-text-image-teaser="tab-nav-item"].text-image-teaser__tab-nav-item--active');
        this.$magicLine = this.$textImageTeaser.querySelector('[data-text-image-teaser="magic-line"]');
        this.activeClass = 'text-image-teaser__tab-nav-item--active';
        this.activeItemXPos = 0;
        this.activeItemWidth = 0;
        this.isDesktopBp = window.matchMedia('(min-width: 1024px)');
        this.$sliderContainer = this.$textImageTeaser.querySelector('[data-text-image-teaser="slider"]');
        this.init();
    }

    init () {
        if (this.$sliderContainer) {
            this.initSlider();
        }

        this.setMagicLine();
        this.magicLine();
        this.events();

        window.resizeHandler.customFunctions.push(() => {
            this.setMagicLine();
            this.magicLine();
        });
    }

    initSlider () {
        this.slider = new Swiper(this.$sliderContainer, {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 500,
            autoHeight: false,
            navigation: {
                nextEl: this.$textImageTeaser.querySelector('.slider-button-next'),
                prevEl: this.$textImageTeaser.querySelector('.slider-button-prev')
            },
            pagination: {
                el: this.$textImageTeaser.querySelector('.slider-pagination'),
                type: 'fraction',
                formatFractionCurrent: function (number) {
                    return ('0' + number).slice(-2);
                },
                formatFractionTotal: function (number) {
                    return ('0' + number).slice(-2);
                }
            },
            on: {
                slideChange: (slider) => {
                    const activeIndex = slider.activeIndex;

                    this.$alltabNav.forEach(($tab, index) => {
                        $tab.classList.remove(this.activeClass);

                        if (index === activeIndex) {
                            const linkX = Math.round($tab.offsetLeft);
                            const linkW = Math.round($tab.getBoundingClientRect().width);
                            this.$magicLine.style.setProperty('--posX', `${linkX}px`);
                            this.$magicLine.style.setProperty('--width', `${linkW}px`);
                            $tab.classList.add(this.activeClass);
                            this.centerTab($tab);
                        }
                    });
                }
            }

        });
    }

    events () {
        this.$tabNav.addEventListener('mouseleave', () => {
            const $newActiveTab = this.$textImageTeaser.querySelector('[data-text-image-teaser="tab-nav-item"].text-image-teaser__tab-nav-item--active');
            this.activeItemXPos = Math.round($newActiveTab.offsetLeft);
            this.activeItemWidth = Math.round($newActiveTab.getBoundingClientRect().width);
            this.$magicLine.style.setProperty('--posX', `${this.activeItemXPos}px`);
            this.$magicLine.style.setProperty('--width', `${this.activeItemWidth}px`);
        });

        // scroll to center
        this.$alltabNav.forEach(link => {
            if (!this.isDesktopBp.matches) {
                link.addEventListener('click', () => {
                    this.centerTab(link);
                });
            }
        });
    }

    setMagicLine () {
        if (this.$activeTab) {
            this.activeItemXPos = Math.round(this.$activeTab.offsetLeft);
            this.activeItemWidth = Math.round(this.$activeTab.getBoundingClientRect().width);
            this.$magicLine.style.opacity = 1;
            this.$magicLine.style.setProperty('--posX', `${this.activeItemXPos}px`);
            this.$magicLine.style.setProperty('--width', `${this.activeItemWidth}px`);
        }
    }

    magicLine () {
        this.$alltabNav.forEach((link, index) => {
            const linkX = Math.round(link.offsetLeft);
            const linkW = Math.round(link.getBoundingClientRect().width);

            link.addEventListener('mouseover', () => {
                this.$magicLine.style.opacity = 1;
                this.$magicLine.style.setProperty('--posX', `${linkX}px`);
                this.$magicLine.style.setProperty('--width', `${linkW}px`);
            });

            link.addEventListener('click', (e) => {
                this.$magicLine.style.setProperty('--posX', `${linkX}px`);
                this.$magicLine.style.setProperty('--width', `${linkW}px`);
                this.$alltabNav.forEach($tab => {
                    $tab.classList.remove(this.activeClass);
                });

                link.classList.add(this.activeClass);
                this.slider.slideTo(index);
            });
        });
    }

    centerTab (el) {
        if (!this.isDesktopBp.matches) {
            const link = el;
            const parentWidth = this.$tabNav.offsetWidth;
            const itemWidth = link.offsetWidth;
            const itemPosition = link.offsetLeft;
            const scrollAmount = itemPosition - (parentWidth - itemWidth) / 2;
            this.$tabNav.scrollLeft = scrollAmount;
        }
    }
}

export { TextImageTeaser };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $textImageTeasers = $context.querySelectorAll('[data-text-image-teaser="root"]');

        for (let i = 0; i < $textImageTeasers.length; i++) {
            const $textImageTeaser = new TextImageTeaser($textImageTeasers[i]);
            $textImageTeaser.init();
        }
    }
});
